import React, { useEffect, useState } from "react"
import { useNavigate, useParams, Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import {
   getStorage,
   ref,
   uploadBytesResumable,
   getDownloadURL,
} from "firebase/storage"
import app from "../../firebase"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import { Publish } from "@material-ui/icons"
// Data
import { updateImage } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Wrapper,
   Main,
   Title,
   StyledForm,
   FormItem,
   StyledLabel,
   StyledInput,
   StyledButton,
   ButtonContainer,
   ButtonWrapper,
   Message,
   CreateImage,
   UploadIcon,
   TitleWrapper,
} from "./Image.styles"

const Image = () => {
   const { imageId } = useParams()
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")
   const [imageInputs, setImageInputs] = useState({})

   const image = useSelector((state) =>
      state.image.images.find((image) => image?._id === imageId)
   )

   const handleChange = (e) => {
      setImageInputs((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleImage = (e) => {
      const storage = getStorage(app)
      const fileName = imageInputs.section + "_" + imageInputs.name
      const storageRef = ref(storage, `image/${fileName}`)
      const uploadTask = uploadBytesResumable(storageRef, e.target.files[0])

      uploadTask.on(
         "state_changed",
         (snapshot) => {
            const progress =
               (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            console.log("Upload is " + progress + "% done")
            switch (snapshot.state) {
               case "paused":
                  console.log("Upload is paused")
                  break
               case "running":
                  console.log("Upload is running")
                  break
               default:
            }
         },
         (error) => {
            console.log(error)
         },
         () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
               console.log("File available at", downloadURL)

               imageInputs((prev) => {
                  return { ...prev, imageLink: downloadURL }
               })
            })
         }
      )
   }

   const deleteImage = (e) => {
      e.preventDefault()
      setImageInputs((prev) => {
         return { ...prev, imageLink: "" }
      })
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      const res = await updateImage(imageId, imageInputs, dispatch)
      if (res === "success") {
         navigate("/images")
      } else {
         setErrorMessage(JSON.stringify(res))
      }
   }

   useEffect(() => {
      if (typeof image === "object" && image !== null) {
         setImageInputs({ ...image })
      }
   }, [image])

   console.log(image)
   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Edit Image</Title>
                  <Link to="/newImage">
                     <StyledButton>Create</StyledButton>
                  </Link>
               </TitleWrapper>
               <StyledForm>
                  <FormItem>
                     <StyledLabel>Section</StyledLabel>
                     <StyledInput
                        type="number"
                        name="section"
                        defaultValue={image.section}
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Name</StyledLabel>
                     <StyledInput
                        type="text"
                        name="name"
                        defaultValue={image.name}
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Image</StyledLabel>
                     <CreateImage src={image.imageLink} />
                     <StyledLabel htmlFor={"image_file"}>
                        <UploadIcon>
                           <Publish />
                        </UploadIcon>
                     </StyledLabel>
                     <StyledInput
                        type="file"
                        id="image_file"
                        name="image_file"
                        style={{ display: "none" }}
                        multiple={false}
                        onChange={(e) => handleImage(e)}
                     />
                     <StyledButton onClick={(e) => deleteImage(e)}>
                        Remove image
                     </StyledButton>
                  </FormItem>
               </StyledForm>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Update</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default Image
